/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Nav_StartInputs */

const en_platform_nav_start = /** @type {(inputs: Platform_Nav_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free`)
};

const pl_platform_nav_start = /** @type {(inputs: Platform_Nav_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij bezpłatnie`)
};

/**
* | output |
* | --- |
* | "Start free" |
*
* @param {Platform_Nav_StartInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_nav_start = /** @type {((inputs?: Platform_Nav_StartInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Nav_StartInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_nav_start(inputs)
	return en_platform_nav_start(inputs)
});